import { Accordion, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { activeIntegrationsSelector } from "../../../../reducers";
import Switch from "../../../../common/Switch";

const accordionKey = "integrations";

export function PersonSettings({ person, setPerson }) {
  const { t } = useTranslation();
  const activeintegrations = useSelector(activeIntegrationsSelector);

  const handleChange = ({target: { id, checked }}) => setPerson(currentPerson => ({
    ...currentPerson,
    settings: {
      ...currentPerson.settings,
      [id]: checked ? "1" : "0",
    },
  }));


  return <Accordion flush alwaysOpen defaultActiveKey={[accordionKey]}>

    <Accordion.Item eventKey={accordionKey}>
      <Accordion.Header>{t("Integrations", "Liittymät")}</Accordion.Header>
      <Accordion.Body>

        <Switch inline id="personEsalaryDisabled" label={t("NoSalaryExport", "Älä lisää palkkoihin")} onChange={handleChange} defaultChecked={person.settings?.personEsalaryDisabled} />

        { activeintegrations.tokenPsa &&
          <Switch inline id="personPsaDisabled" label={t("NoPsa", "Älä lisää PSA:han")} onChange={handleChange} defaultChecked={person.settings?.personPsaDisabled} />
        }

      </Accordion.Body>
    </Accordion.Item>

  </Accordion>;
}
